<template>
    <section>
        <!--工具条-->
        <el-col :span="24" style="padding-bottom: 0px;" size="small">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd" :disabled="!isAuth('permission:add')">添加权限</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-table :data="dataList" highlight-current-row border style="width: 100%;" size="small">
            <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
            <table-tree-column prop="name" treeKey="id" label="名称" width="200" align="center"></table-tree-column>
            <el-table-column prop="parentName" label="上级菜单" width="200" align="center"></el-table-column>
            <el-table-column prop="type" label="类型" align="center">
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.type === 0">目录</el-tag>
                    <el-tag size="small" v-else-if="scope.row.type === 1" type="success">菜单</el-tag>
                    <el-tag size="small" v-else-if="scope.row.type === 2" type="info">按钮</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="orderNum" label="排序号" width="100" align="center"></el-table-column>
            <el-table-column prop="url" label="菜单URL" width="180" align="center"></el-table-column>
            <el-table-column prop="perms" label="授权标识" align="center"></el-table-column>
            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button size="small" type="text" @click="handleEdit(scope.$index, scope.row)" :disabled="!isAuth('permission:update')">编辑</el-button>
                    <!--<el-button size="small" type="text" @click="handleDel(scope.$index, scope.row)" :disabled="!isAuth('permission:del')">删除</el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <!--编辑界面-->
        <el-dialog title="权限更新" :visible.sync="editFormVisible" width="30%">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm" size="small">
                <el-form-item label="类型" prop="type">
                    <el-radio-group v-model="editForm.type">
                        <el-radio v-for="(type, index) in typeList" :label="index" :key="index">{{ type }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="typeList[editForm.type] + '名称'" prop="name">
                    <el-input v-model="editForm.name" :placeholder="typeList[editForm.type] + '名称'"></el-input>
                </el-form-item>
                <el-form-item label="上级菜单" prop="parentName">
                    <el-input v-model="editForm.parentName" placeholder="上级菜单"></el-input>
                </el-form-item>
                <el-form-item v-if="editForm.type === 1" label="菜单路由" prop="url">
                    <el-input v-model="editForm.url" placeholder="菜单路由"></el-input>
                </el-form-item>
                <el-form-item v-if="editForm.type !== 0" label="授权标识" prop="perms">
                    <el-input v-model="editForm.perms" placeholder="授权标识"></el-input>
                </el-form-item>
                <el-form-item v-if="editForm.type !== 2" label="排序号" prop="orderNum">
                    <el-input-number v-model="editForm.orderNum" controls-position="right" :min="0" label="排序号"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading" size="small">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="权限添加" :visible.sync="addFormVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" size="small">
                <el-form-item label="类型" prop="type">
                    <el-radio-group v-model="addForm.type">
                        <el-radio v-for="(type, index) in typeList" :label="index" :key="index">{{ type }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="typeList[addForm.type] + '名称'" prop="name">
                    <el-input v-model="addForm.name" :placeholder="typeList[addForm.type] + '名称'"></el-input>
                </el-form-item>
                <el-form-item label="上级菜单" prop="parentName">
                    <el-input v-model="addForm.parentName" placeholder="上级菜单"></el-input>
                </el-form-item>
                <el-form-item v-if="addForm.type === 1" label="菜单路由" prop="url">
                    <el-input v-model="addForm.url" placeholder="菜单路由"></el-input>
                </el-form-item>
                <el-form-item v-if="addForm.type !== 0" label="授权标识" prop="perms">
                    <el-input v-model="addForm.perms" placeholder="授权标识"></el-input>
                </el-form-item>
                <el-form-item v-if="addForm.type !== 2" label="排序号" prop="orderNum">
                    <el-input-number v-model="addForm.orderNum" controls-position="right" :min="0" label="排序号"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading" size="small">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import {
        getPermissionList,
        removePermission,
        modifyPermission,
        addPermission,
    } from '../../../api/api';
    import TableTreeColumn from '@/components/table-tree-column'
    import { treeDataTranslate } from '@/utils'
    export default {
        data() {
            return {
                filters: {
                    name: ""
                },
                menuList: [],
                typeList: ['目录', '菜单', '按钮'],
                dataList: [],

                listLoading: false,
                sels: [], //列表选中列
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    name: [
                        { required: true, message: '菜单名称不能为空', trigger: 'blur' }
                    ]
                },
                //编辑界面数据
                editForm: {
                    id: '',
                    type: 1,
                    name: '',
                    parentId: 0,
                    parentName: '',
                    url: '',
                    perms: '',
                    orderNum: 0,
                },

                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                addFormRules: {
                    name: [
                        { required: true, message: '菜单名称不能为空', trigger: 'blur' }
                    ]
                },
                //新增界面数据
                addForm: {
                    type: 1,
                    name: '',
                    parentId: 0,
                    parentName: '',
                    url: '',
                    perms: '',
                    orderNum: 0,
                },
                menuListTreeProps: {
                    label: 'name',
                    children: 'children'
                }
            };
        },
        components: {
            TableTreeColumn,
        },
        methods: {
            // 菜单树选中
            menuListTreeCurrentChangeHandle (data, node) {
                this.dataForm.parentId = data.id;
                this.dataForm.parentName = data.name
            },


            getDataList() {
                this.listLoading = true;
                getPermissionList().then((res) => {
                    if(res.data.code === 0){
                        this.dataList = treeDataTranslate(res.data.permissionList, 'id')
                    }else{
                        this.$message.error("获取角色列表失败，请稍后重新获取")
                    }
                    this.listLoading = false;
                })
            },
            //删除
            handleDel: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    let para = {
                        id: row.id
                    };
                    removePermission(para).then((res) => {
                        if (res.data.code === 0) {
                            this.$message.success('删除成功');
                        } else {
                            this.$message.error("删除失败")
                        }
                        this.listLoading = false;
                        this.getDataList();

                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            let para = Object.assign({}, this.editForm);
                            modifyPermission(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('修改成功');
                                } else {
                                    this.$message.error('修改失败');
                                }
                                this.editLoading = false;
                                this.$refs['editForm'].resetFields();
                                this.editFormVisible = false;
                                this.getDataList();
                            });
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            let para = Object.assign({}, this.addForm);
                            addPermission(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('添加成功');
                                } else {
                                    this.$message.error('添加失败');
                                }
                                this.addLoading = false;
                                this.$refs['addForm'].resetFields();
                                this.addFormVisible = false;
                                this.getDataList();
                            });
                        });
                    }
                });
            }
        },
        activated() {
            this.menuList = sessionStorage.getItem("menuList");
            this.getDataList();
        }
    };
</script>

<style slot-scope lang="scss">
    .hiddenRow {
        display: none;
    }

    .searchForm {
        padding: 10px;

        span.label {
            margin-right: 10px;
        }

        span.attention {
            color: #e50021;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/modules/sys/menu.vue